<template>
    <div class="public-offer-heading">
        <default-title :line-height="21" :size="16">
            {{ productTitle }}
            <span v-for="(product, index) in viewedProduct" :key="index">
                <a target="_blank" :href="product.link">{{ product.name }}</a
                ><template v-if="index !== viewedProduct.length - 1">, </template>
            </span>
        </default-title>
        <default-divider :height="2"></default-divider>
    </div>
</template>

<script>
import DefaultTitle from "@components/Typography/DefaultTitle"
import DefaultDivider from "@components/Typography/DefaultDivider"

export default {
    name: "PublicOfferHeading",
    props: {
        viewedProduct: {
            type: Array,
            default: () => [],
            required: true
        },
        productTitle: {
            type: String,
            default: "",
            required: true
        }
    },
    components: { DefaultDivider, DefaultTitle }
}
</script>

<style scoped lang="sass">
.public-offer-heading
    a
        color: #3451BE
        text-decoration: underline
    .default-title
        margin: 10px 14px
        @media (max-width: 640px)
            margin: 15px 20px 20px 20px
        @media (max-width: 480px)
            margin: 15px 20px 20px 14px
</style>
